import React from "react";
import { curriculum } from "../data/curriculum";
import { useProgress } from "../context/ProgressContext";
import { useAuth } from "../context/AuthContext";

const FREE_LESSONS = ["w1l1"];

export default function Sidebar({ currentLessonId, onSelectLesson }) {
  const { isComplete } = useProgress();
  const { hasFullAccess } = useAuth();

  let lessonNumber = 0;

  return (
    <div
      style={{
        width: 240,
        minHeight: "100%",
        background: "#f8fafc",
        borderRight: "1px solid #e2e8f0",
        overflowY: "auto",
        flexShrink: 0,
      }}
    >
      {curriculum.map((section) => (
        <div key={section.id}>
          <div
            style={{
              padding: "10px 14px 6px",
              fontSize: 10,
              fontWeight: 800,
              color: "#009dc4",
              textTransform: "uppercase",
              letterSpacing: 1,
              borderBottom: "1px solid #e2e8f0",
              background: "#f0f9ff",
            }}
          >
            {section.title}
          </div>
          {section.lessons.map((lesson) => {
            lessonNumber += 1;
            const num = lessonNumber;
            const isActive = lesson.id === currentLessonId;
            const done = isComplete(lesson.id);
            const isFree = FREE_LESSONS.includes(lesson.id);
            const locked = !isFree && !hasFullAccess;

            return (
              <button
                key={lesson.id}
                onClick={() => onSelectLesson(lesson.id)}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 8,
                  width: "100%",
                  textAlign: "left",
                  background: isActive ? "#e0f2fe" : "none",
                  border: "none",
                  borderLeft: isActive
                    ? "3px solid #009dc4"
                    : "3px solid transparent",
                  borderBottom: "1px solid #f1f5f9",
                  padding: "10px 12px",
                  cursor: "pointer",
                  transition: "background 0.1s",
                  fontFamily: "inherit",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.background = "#f0f9ff";
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.background = "none";
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    marginTop: 1,
                    flexShrink: 0,
                    color: done ? "#16a34a" : locked ? "#94a3b8" : "#009dc4",
                  }}
                >
                  {done ? "✓" : locked ? "🔒" : `${num}.`}
                </span>
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: isActive ? 700 : 500,
                      color: isActive ? "#007a9e" : locked ? "#94a3b8" : "#334155",
                      lineHeight: 1.4,
                    }}
                  >
                    {lesson.title}
                  </div>
                  {isFree && (
                    <span
                      style={{
                        fontSize: 10,
                        color: "#16a34a",
                        fontWeight: 700,
                        background: "#dcfce7",
                        padding: "1px 5px",
                        borderRadius: 3,
                        marginTop: 2,
                        display: "inline-block",
                      }}
                    >
                      FREE
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}